<template>
  <v-container>
    <div class="info-title">
      <span v-if="!hasSlot('title')">{{ title }}</span>
      <slot name="title" />
    </div>
    <div class="info-content">
      <span v-if="!hasSlot('content')">{{ content }}</span>
      <slot name="content" />
      <div>
        <slot name="action" />
      </div>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  methods: {
    hasSlot(name = 'default') {
      return !!this.$slots[name];
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.info-title {
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: 500;
  text-align: center;

  @media (max-width: 575px) {
    font-size: 14px;
  }
}

.info-content {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}
</style>
